module.exports = __webpack_public_path__ + "static/media/main_bg.93407c7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/share/img/main_bg.png
// module id = 1522
// module chunks = 0